<script lang="ts">
  import type { Snippet } from 'svelte';

  import type { TeoCore } from '@/teoCore/TeoCore';
  import type { TeoText } from '@/teoCore/text/TeoText';

  import { TeoContextProvider } from '.';
  import { TeoActiveText } from '../use-teo-event-observer.svelte';

  type TeoActiveTextSnippet = Snippet<[{ teoCore: TeoCore; teoText: TeoText }]>;

  let { teoCore, children }: { teoCore?: TeoCore; children: TeoActiveTextSnippet } = $props();
  let core = $derived(teoCore || window?.__TEO__getCore?.());
  let teoText = $derived(core ? new TeoActiveText(core) : undefined);
</script>

<TeoContextProvider {teoCore}>
  {#if teoText?.current}
    {#key teoText.current}
      {@render children({ teoCore: core, teoText: teoText.current })}
    {/key}
  {/if}
</TeoContextProvider>
